export default __webpack_public_path__ + "static/media/account_circle.d72654c4.svg";